'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _commonFunctions = require('../../helpers/commonFunctions');

function populateCoverageData(context, data) {
  context.updateProp('application.additional_data.policy_type', data.additional_data.policy_type);
  context.updateProp('application.additional_data.billing_date', data.additional_data.billing_date);
}

function populateQuestionnaireData(context, propPrefix, data) {
  for (var q = 1; q <= 8; q++) {
    (0, _commonFunctions.fillQuestion)(context, propPrefix, Object.values(data), q);
  }
}

function populateApplicantsAdditionalData(context, data) {
  var mqAnswers = data.additional_data.applicants[0].additional_data.mq;
  populateQuestionnaireData(context, 'applicant[0]', mqAnswers);
}

function populateProductSpecificData(context, data) {
  populateCoverageData(context, data);
  populateApplicantsAdditionalData(context, data);
}

exports.default = function (context) {
  (0, _commonFunctions.populateQuoteData)(context, populateProductSpecificData);
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/rimisecureadvantageplus/quote.js
// module id = 1755
// module chunks = 0